import React from 'react';
import { ToastContainer } from 'react-toastify';

export default function ToastRoot() {
  return (
    <ToastContainer
      position="bottom-left"
      autoClose={1500}
      hideProgressBar
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss={false}
      draggable={false}
      pauseOnHover
      theme="light"
    />
  );
}
